<h3>Thanks for filling out your information!</h3>
<div mat-dialog-content>
    <p>We need some time to check 'Your BwB Passport. After successful checking, you'll get an email with access to
        'Trade Blotter' and 'USD Concierge Cash Management'.</p>
</div>
<div mat-dialog-actions>
    <div>
        <button class="mb-10" mat-raised-button color="primary" type="button" [mat-dialog-close]="true">Got it</button>
    </div>
</div>